<div class="card">
    <div class="card-header d-flex flex-row align-items-center justify-content-between">
        <h6 class="font-weight-bold text-primary">Re-Assign Leads to Counsellor</h6>
        <button type="button" class="btn btn-danger" style="float: right;" (click)="onClose()">X</button>
    </div>
    <div class="card-body">
        <div class="form-group">
            <label for="counsellorSelect" class="font-weight-bold">Select a Counsellor</label>
            <select id="counsellorSelect" class="form-control counsellor-select" [(ngModel)]="selectedCounsellor" name="counsellorSelect">
                <option [ngValue]="null" disabled>Select a Counsellor</option>
                <option *ngFor="let counsellor of counsellorList" [ngValue]="counsellor.refNo">
                    {{ counsellor?.userName }}
                </option>
            </select>
        </div>
    </div>
    <div class="card-footer">
        <button type="button" class="btn btn-primary" (click)="onAssign()">Assign</button>
        <button type="button" class="btn btn-secondary" style="margin-left: 10px;" (click)="onClose()">Close</button>
    </div>
</div>